<template>
	<div class="ipDiv">
		<el-input ref="ipv1" @focus="focusInput('ipv2')" v-model="ipv1" class="ip-el-input" size="large"></el-input>
		<div class="ipDiv-dot">.</div>
		<el-input ref="ipv2" @focus="focusInput('ipv3')" v-model="ipv2" class="ip-el-input" size="large"></el-input>
		<div class="ipDiv-dot">.</div>
		<el-input ref="ipv3" @focus="focusInput('ipv4')" v-model="ipv3" class="ip-el-input" size="large"></el-input>
		<div class="ipDiv-dot">.</div>
		<el-input ref="ipv4" v-model="ipv4" class="ip-el-input" @blur="check=null" size="large"></el-input>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				ipv1: '',
				ipv2: '',
				ipv3: '',
				ipv4: '',
				check: null,
				ipInfo: {
					flag: false,
					ip: ''
				},
				ipInfo1: {
					flag: false,
					ip: ''
				}
			}
		},
		mounted() {
			//console.log('IP Mounted');
			//this.init()
		},
		created() {
			//console.log('IP Created');
		},
		methods: {
			init() {
				this.initEvent()
				this.initIpconponent()
			},
			initIpconponent() {
				this.ipv1 = this.configIp.split('.')[0] || ''
				this.ipv2 = this.configIp.split('.')[1] || ''
				this.ipv3 = this.configIp.split('.')[2] || ''
				this.ipv4 = this.configIp.split('.')[3] || ''
				this.ipInfo = this.ipInfo1
				if (this.autoFocus) {
					this.$refs.ipv1.focus()
				}
			},
			// 返回ip信息
			returnIpInfo() {
				if (this.ipv1 === null || this.ipv2 === null || this.ipv3 === null || this.ipv4 === null) {
					this.ipInfo.flag = false
				} else {
					this.ipInfo.flag = true
				}
				this.ipInfo.ip = this.ipv1 + '.' + this.ipv2 + '.' + this.ipv3 + '.' + this.ipv4
				this.$emit('getIp', this.ipInfo)
			},
			// 当前聚焦输入框,预先聚焦下一个输入框
			focusInput(flag) {
				this.check = flag
			},
			// 初始化键盘事件,监听enter按下事件
			initEvent() {
				document.addEventListener('keydown', this.getEventType)
			},
			// 各分支IP校验正则表达式
			valid(val) {
				let reg = /^\d{1,}$/
				return reg.test(val)
			},
			// enter按键后，所聚焦的输入框
			getEventType(e) {
				if (e.keyCode === 13 || e.keyCode === 110) {
					switch (this.check) {
						case 'ipv1':
							if (this.ipv4 === null) return
							this.$refs.ipv1.focus()
							break
						case 'ipv2':
							if (this.ipv1 === null) return
							this.$refs.ipv2.focus()
							break
						case 'ipv3':
							if (this.ipv2 === null) return
							this.$refs.ipv3.focus()
							break
						case 'ipv4':
							if (this.ipv3 === null) return
							this.$refs.ipv4.focus()
							break
							// default:
							//   this.$refs.ipv1.focus()
					}
				}
			}
		},
		watch: {
			'ipv1': {
				handler(cur) {
					console.log('cur:' + this.valid(cur))
					if (this.valid(cur)) {
						if (Number(cur) === 0) {
							return this.ipv1 = null
						}
						if (this.ipType === 'ip') {
							if (cur > 253) {
								this.ipv1 = 253
								this.$refs.ipv2.focus()
								this.$message({
									message: '只能输入1~253之间的数字',
									type: 'warning',
									duration: 1000
								})
							}
						} else if (this.ipType === 'subnet') {
							if (cur > 255) {
								this.ipv1 = 255
								this.$refs.ipv2.focus()
								this.$message({
									message: '只能输入1~255之间的数字',
									type: 'warning',
									duration: 1000
								})
							}
						}
						if (cur.length === 3) {
							this.$refs.ipv2.focus()
						}
						this.returnIpInfo()
					} else {
						this.ipv1 = null
					}
				}
			},
			'ipv2': {
				handler(cur) {
					console.log('cur:' + this.valid(cur))
					if (this.valid(cur)) {
						if (cur > 255) {
							this.ipv2 = 255
							this.$refs.ipv3.focus()
						} else {
							this.ipv2 = Number(cur)
						}
						if (cur.length === 3) {
							this.$refs.ipv3.focus()
						}
						this.returnIpInfo()
					} else {
						this.ipv2 = null
					}
				}
			},
			'ipv3': {
				handler(cur) {
					console.log('cur:' + this.valid(cur))
					console.log('cur:' + cur)
					if (this.valid(cur)) {
						if (cur > 255) {
							this.ipv3 = 255
							this.$refs.ipv4.focus()
						} else {
							this.ipv3 = Number(cur)
						}
						if (cur.length === 3) {
							this.$refs.ipv4.focus()
						}
						this.returnIpInfo()
					} else {
						this.ipv3 = null
					}
				}
			},
			'ipv4': {
				handler(cur) {
					console.log('cur:' + this.valid(cur))
					if (this.valid(cur)) {
						if (Number(cur) === 0) {
							return this.ipv4 = null
						}
						if (cur > 254) {
							this.ipv4 = 254
						}
						if (cur === 0) {
							this.ipv4 = null
						}
						this.returnIpInfo()
					} else {
						this.ipv4 = null
					}
				}
			}
		},
		props: {
			// 是否需要自动聚焦
			autoFocus: {
				type: Boolean,
				default: false
			},
			ipType: { // ip(dns),subnet
				String: 'ip',
				default: false
			},
			configIp: {
				type: String,
				default: String
			},
			defaultIp: {
				type: String,
				default: ''
			}
		},
		// 销毁键盘监听事件,enter按下事件
		destroyed() {
			document.removeEventListener('keydown', this.getEventType)
		}
	}
</script>
<style>
	.ipDiv {
		width: 100%;
		display: flex;
		border: 1px solid #EEEEEE;
		border-radius: 4px;
	}

	.ip-el-input {
		width: 25%;
		text-align: center;
	}

	.ipDiv .el-input__inner,
	.ipDiv .el-input__inner:focus {
		text-align: center;
		border: 0;
	}

	.el-input__inner {
		width: 100%;
	}

	.ipDiv-dot {
		width: 3%;
	}
</style>
